import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: 'loading',   // 'idle' | 'listening' | 'speaking'
  muted: false, 
  error: null,
};

const aiSlice = createSlice({
  name: 'ai',
  initialState,
  reducers: {
    setListening: (state) => {
      state.status = 'listening';
      state.error = null;
    },
    setSpeaking: (state) => {
      state.status = 'speaking';
      state.error = null;
    },
    setIdle: (state) => {
      state.status = 'idle';
      state.error = null;
    },

    // ------- mute -------
    setMuted: (state, { payload }) => {
      state.muted = !!payload; // true/false
    },
    toggleMuted: (state) => {
      state.muted = !state.muted;
    },
    mute: (state) => { state.muted = true; },
    unmute: (state) => { state.muted = false; },
  },
});

export const {
  setListening,
  setSpeaking,
  setIdle,
  setMuted,
  toggleMuted,
  mute,
  unmute,
} = aiSlice.actions;

export default aiSlice.reducer;

export const selectAiStatus = (s) => s.ai?.status;
export const selectIsMuted = (s) => s.ai?.muted;
